import { useNavigate } from "react-router-dom";
import Divider from "../components/common/aesthetics/Divider.jsx";
import AppBreadcrumbs from "../components/common/breadcrumbs/AppBreadcrumbs.jsx";
import ChartAcumulado from "../components/common/chart/ChartAcumulado.jsx";
import ChartPrecintas from "../components/common/chart/ChartPrecintas.jsx";
import TableDailyReceipts from "../components/common/table/TableDailyReceipts.jsx";
import Page from "../components/layout/Page.jsx";
import { useAuth } from "../contexts/AuthProvider.jsx";

const Home = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  if (!auth) {
    navigate("/login");
  }

  return (
    <Page>
      <AppBreadcrumbs />
      <div>
        <h1 className="font-bold text-2xl">Panel de control</h1>
        <span className="text-text-secondary">Estadísticas de ventas de alcoholes y recepciones pendientes.</span>
      </div>
      <Divider className="mb-6" />
      <div className="grid lg:grid-cols-2 md:grid-cols-1 gap-6">
        <ChartAcumulado />
        <ChartPrecintas />
        <div className="col-span-2">
          <TableDailyReceipts />
        </div>
      </div>
    </Page>
  );
};

export default Home;
